import { OwnProps } from '~/types/ownProps';

const step = {
  route: '/homeowners-insurance/quotes/property-details',
  isAccessible: ({ application: { isAutoOnly } }: OwnProps) => !isAutoOnly,
  breadcrumbStep: 'property',
};

export default step;
